import React from 'react';
import { useTheme } from '@fluentui/react';
import { Delete16Regular as DeleteIcon } from '@fluentui/react-icons';
import { IAppTheme } from 'common/theme/AppTheme';

import { IButtonImplProps } from '../BaseButton.types';
import { IconButton } from '../IconButton';

import { getStyles } from './DeleteIconButton.styles';

const DeleteIconButton = (props: IButtonImplProps) => {
  const theme = useTheme() as IAppTheme;
  const styles = getStyles(theme);
  const { className, ...otherProps } = props;
  return (
    <IconButton className={className} styles={styles.button} {...otherProps}>
      <DeleteIcon primaryFill={theme.appColors?.red600ToCrimson70} />
    </IconButton>
  );
};

export default DeleteIconButton;
